import React, { useEffect, useCallback, useState } from 'react';
import Badge from '@material-ui/core/Badge';
import { DataList } from '../../../components';
import { paths } from '../../../routes';
import { useResidences } from '../../../hooks/theme.hook';
import { useApi, useAuth } from '../../../hooks';
import { ReportStatus } from '../../../types';

export const PRMAssistanceList: React.FC = () => {
  const { residenceOptions } = useResidences();
  const [managers, setManagers] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const { getManagerList, getUsersNameAndLastName } = useApi();
  const { auth } = useAuth();
  const [role = ''] = auth?.roles || [];

  const getManagers = useCallback(async () => {
    try {
      const managers = await getManagerList();
      setManagers(managers);
    } catch (error) {
      console.log('get anomalies error', error);
    }
  }, [getManagerList]);

  const getUsers = useCallback(async () => {
    try {
      const users = await getUsersNameAndLastName();
      setUsers(users);
    } catch (error) {
      console.log('get anomalies error', error);
    }
  }, [getUsersNameAndLastName]);

  useEffect(() => {
    getManagers();
    getUsers();
  }, [getManagers, getUsers]);

  const object = {
    circulationStartDate: {
      label: 'Date de circulation du',
      type: 'date',
      maxDateField: 'circulationEndDate',
      grid: 3,
    },
    circulationEndDate: {
      label: 'AU',
      type: 'date',
      minDateField: 'circulationStartDate',
      grid: 3,
    },
    userCPCode: {
      label: 'Prénom Nom',
      type: 'autocomplete',
      grid: 3,
      options: users,
      getOptionLabel: (user: any) => (user?.firstName ? `${user.firstName} ${user.lastName}` : ''),
      getOptionSelected: (user: any) => user.userCPCode,
    },
    residenceShortCode: {
      label: 'Résidence',
      type: 'select',
      options: residenceOptions,
      grid: 3,
    },
    serviceName: {
      label: 'Numéro du train',
      type: 'text',
      grid: 3,
    },
    reportId: {
      label: 'Numéro du rapport',
      type: 'text',
      grid: 3,
    },
    assistanceNature: {
      label: "Nature de l'assistance",
      type: 'select',
      grid: 3,
      options: [
        {
          value: 'Prise en charge',
          label: 'Prise en charge',
        },
        {
          value: 'Refus de prise en charge',
          label: 'Refus de prise en charge',
        },
      ],
    },
    reportStatus: {
      label: 'Statut du rapport',
      type: 'select',
      name: 'reportStatus',
      options: [
        {
          label: 'Enregistré',
          value: ReportStatus.saved,
        },
        {
          label: 'Envoyé',
          value: ReportStatus.sent,
        },
      ],
      grid: 3,
    },
    authorCPCode: {
      label: 'Managers',
      type: 'select',
      name: 'manager',
      options: managers.map((x: any) => {
        return {
          label: x.firstName + ' ' + x.lastName,
          value: x.UseName,
        };
      }),
      grid: 3,
    },
  };
  if (role === 'Agent' || role === 'Manager') delete object['authorCPCode'];
  return (
    <DataList
      formPath={paths.prmAssistanceNew.path}
      filterFields={object}
      columns={[
        {
          label: 'ID',
          dataKey: 'reportId',
          renderColumn: (report: any) => (
            <Badge color="secondary" variant="dot" invisible={!report.fieldReportsDto.getResponse}>
              {report.reportId}
            </Badge>
          ),
        },
        {
          label: 'Circulation',
          dataKey: 'circulationDateFormat',
        },
        {
          label: 'Train',
          dataKey: 'serviceName',
        },
        {
          label: 'Agent',
          dataKey: 'agent',
        },
        {
          label: 'Residence',
          dataKey: 'agentResidence',
        },
        {
          label: "Nature de l'assistance",
          dataKey: 'fieldReportsDto.assistanceNature',
        },
        {
          label: 'Statut',
          dataKey: 'reportStatus',
        },
      ]}
    />
  );
};

export default PRMAssistanceList;
